// extracted by mini-css-extract-plugin
export var bodyContainer = "modalpromo-module--body-container--af16f";